import { object, string } from '@calendly/form/validation'
import { I18n } from '@calendly/i18n'

const SLUG_REGEX = /^[a-z0-9_-]+$/

export const getValidationSchema = () => object({
  slug: string()
    .required(I18n.t('activerecord.errors.models.event_type_base.attributes.slug.blank'))
    .matches(SLUG_REGEX, {
      message: I18n.t('activerecord.errors.models.event_type_base.attributes.slug.invalid'),
      excludeEmptyString: true
    })
})
